import type { View } from "../types";

// Shown for any address the app doesn't know.
export default function notFound(): View {
  return {
    title: "Page not found",
    async mount(el, ctx) {
      ctx.useStyle(`.nf{position:fixed;inset:0;display:grid;place-content:center;text-align:center;gap:14px;padding:24px}
.nf h1{margin:0;font-weight:700;font-size:1.6rem} .nf p{margin:0;color:var(--steel)}
.nf a{color:var(--amber);min-height:44px;display:inline-flex;align-items:center;justify-content:center}`);
      el.innerHTML = `<main class="nf"><h1>Page not found</h1><p>There is nothing at this address.</p><a href="/lab/">Go to the virtual lab</a></main>`;
    },
    unmount() {}
  };
}
